export default "__VITE_ASSET__BRRfudxu__"